import { render, staticRenderFns } from "./SidFontSize.vue?vue&type=template&id=b55ebe42"
import script from "./SidFontSize.vue?vue&type=script&lang=js"
export * from "./SidFontSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports